import { ForecastListHeader } from 'common/grid-list-items/list-item-header.js';
import { HTMLRenderer } from 'common/html-renderer.js';
import { MaybeIconPropsAll } from 'common/icon/icon.js';

export type ActivitySummaryProps = MaybeIconPropsAll & {
  content: string;
  title?: string;
};

export const ActivitySummary = ({ content, title, ...icon }: ActivitySummaryProps) => {
  if (content) {
    return (
      <div className="u-mT-sm" style={{ minHeight: '2rem' }}>
        <ForecastListHeader {...icon} title={title} classes="grid-list-item" />
        <HTMLRenderer classes="u-text-sm u-block u-textGrey u-mT-sm" content={content} />
      </div>
    );
  }
  return null;
};
